import React from "react";
import "./learner-home-widget.module.scss";
import Slider from "react-slick";
import { Card } from "./components";
import { Tags } from "../../LearnerHome/util";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faChevronLeft,
} from "@fortawesome/pro-solid-svg-icons";

const WidgetKeys = Object.freeze({
  "continue-learning": Tags.ContinueLearning,
  "top-picks": Tags.TopPicks,
  playlist: Tags.PlaylistsForUser,
  "inspired-by-your-subjects": Tags.InspiredbySubjects,
});

const ArrowButton = ({ onClick, className, style, children, ...rest }) => {
  return (
    <div
      className={className}
      onClick={onClick}
      style={{
        background: "linear-gradient(103.81deg, #FFC12D 0%, #D417B7 100%)",
      }}
    >
      {children}
    </div>
  );
};

const LearnerHomeWidgetBlock = (props) => {
  const { contentFields, widgets } = props;

  const fields = contentFields.reduce(
    (acc, curr) => ({
      ...acc,
      [curr.fieldDefinitionKey]: { ...curr },
    }),
    {}
  );

  const { title, text, widget } = JSON.parse(fields.Widget.data);
  const { slides, settings } = widgets[WidgetKeys[widget]] || {};
  const renderShowAllBtn = false;

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    nextArrow: (
      <ArrowButton>
        <FontAwesomeIcon icon={faChevronRight} color="#fff" />
      </ArrowButton>
    ),
    prevArrow: (
      <ArrowButton>
        <FontAwesomeIcon icon={faChevronLeft} color="#fff" />
      </ArrowButton>
    ),
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 736,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
    ],
  };

  return (
    <section className="learner-widget-block">
      <h4 className="learner-widget-block__title">{title}</h4>
      <p className="learner-widget-block__text">{text}</p>
      <Slider {...sliderSettings}>
        {Array.isArray(slides) &&
          slides.map((o, i) => <Card key={i} data={o} settings={settings} />)}
      </Slider>
      {renderShowAllBtn && (
        <div style={{ textAlign: "right" }}>
          <button className="learner-widget-block__btn">See all</button>
        </div>
      )}
    </section>
  );
};

export default LearnerHomeWidgetBlock;



// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/learner-home-widget-block/learner-home-widget-block.js